import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledCategoryInfoMobile = styled.div<{ categoryColor: string }>`
  display: flex;
  height: auto;
  min-height: unset;
  flex-direction: column;

  /* Break out of mobile container*/
  margin-right: -16px;
  margin-left: -16px;
  background-color: ${({ categoryColor }) => categoryColor};

  .heading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .banner {
      position: relative;
      z-index: 2;
      display: flex;
      width: 100px;
      height: 100px;
      align-items: center;
      justify-content: center;
      margin: 24px auto 0 auto;
      background-color: white;
      border-radius: 50%;
    }

    .info {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .category-name {
        margin-bottom: 8px;
      }

      .reviewed {
        width: 80%;
        text-align: center;

        a {
          color: black;
          font-weight: 700;
        }
      }
    }
  }

  .content {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 16px 16px 16px 16px;
    background-color: white;
    border-radius: 20px 20px 0px 0px;

    .description {
      padding: 16px;
      border: 1px solid #f2f2f2;
      margin-top: 24px;
      background-color: white;
      border-radius: ${theme.borderRadius};

      &.no-des {
        height: 20px;
        visibility: hidden;
      }
    }
  }
`

export const StyledCategoryInfoDesktop = styled.div<{ categoryColor: string }>`
  display: flex;
  width: calc(100vw - 16px);
  height: auto;
  min-height: unset;
  flex-direction: column;
  margin-left: calc((50vw - 50% - 8px) * -1);
  background-color: ${({ categoryColor }) => categoryColor};

  .heading {
    display: flex;
    width: 768px;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    margin: 0 auto;

    .banner {
      position: relative;
      z-index: 2;
      display: flex;
      width: 168px;
      height: 168px;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      margin-right: 32px;
      background-color: white;
      border-radius: 50%;
    }

    .info {
      position: relative;
      z-index: 2;
      margin-bottom: 32px;

      .category-name {
        margin-bottom: 8px;
      }

      .reviewed {
        a {
          color: black;
          font-weight: 700;
        }
      }
    }
  }

  .content {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    margin-top: -122px;
    background-color: white;
    border-radius: 40px 40px 0px 0px;

    &.no-description {
      height: 150px;
    }

    .description {
      width: 768px;
      padding: 24px;
      border: 1px solid #f2f2f2;
      margin-top: 122px;
      background-color: white;
      border-radius: ${theme.borderRadius};
    }
  }
`
